import React from "react";
import styled from "styled-components";
// Assets
import RollerIcon from "../../assets/svg/Services/RollerIcon";
// import MonitorIcon from "../../assets/svg/Services/MonitorIcon";
// import BrowserIcon from "../../assets/svg/Services/BrowserIcon";
import IconBasic_settings from "../../assets/svg/Services/IconBasic_settings";
import IconUsers from "../../assets/svg/Services/IconUsers";
import IconAccountEdit from "../../assets/svg/Services/IconAccountEdit";
import IconColorPalette from "../../assets/svg/Services/IconColorPalette";
// import {FcCollaboration} from 'react-icons/fc';
export default function ServiceBox({ icon, title, subtitle }) {
  let getIcon;

  switch (icon) {
    case "roller":
      getIcon = <IconUsers />;
      break;
    case "monitor":
      getIcon = <IconColorPalette />;
      break;
    case "browser":
      getIcon = <IconAccountEdit />;
      break;
    case "printer":
      getIcon = <IconBasic_settings />;
      break;
    default:
      getIcon = <RollerIcon />;
      break;
  }

  return (
    <Wrapper className="flex flexColumn">
      <IconStyle>{getIcon}</IconStyle>
      <TitleStyle className="font20 extraBold">{title}</TitleStyle>
      <SubtitleStyle className="font13">{subtitle}</SubtitleStyle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const IconStyle = styled.div`
  @media (max-width: 860px) {
    margin: 0 auto;
  }
`;
const TitleStyle = styled.h2`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 10px 0;
  color: #9e9d24;
  @media (max-width: 860px) {
    padding: 20px 0;
  }
`;
const SubtitleStyle = styled.p`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  color: #111;
  font-weight: 600;
  font-size: 14px;
  text-align: justify;
`;
